import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

const EntityMegaHeaderModuleAsyncComponent = AsyncComponent(async () => import('./entity-mega-header-module' /* webpackChunkName: "entity-mega-header-module" */ ));

export const EntityMegaHeaderModuleAsync = (props) => {
  return <EntityMegaHeaderModuleAsyncComponent {...props}/>


  //add suspense only if needed
  // <React.Suspense fallback={<div/>}>
  //   <TemplateModuleAsyncComponent {...props}/>
  // </React.Suspense>
}
